import getField from '../getField'

const getUserame = user => getField(user, 'userProfile.userName')

export default getUserame



// WEBPACK FOOTER //
// ./src/utilities/Data/User/getUsername.js